import { useState, useEffect } from "react";
import { CommandsQueries } from "../../../requests/queries/CommandsQueries";
import "./commands.css";
import { useParams } from "react-router-dom";
import LoaderSpinner from "../../common/LoaderSpinner";
import EditCommandModal from "./components/EditCommandModal";

export default function Commands() {
    const { id: projectId } = useParams();
    
    const [commands, setCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadCommands();
    }, []);

    const loadCommands = async () => {
        setIsLoading(true);
        const data = await CommandsQueries.getAll(projectId);
        setCommands(data);
        setIsLoading(false);
    }

    if (isLoading) {
        return <LoaderSpinner fullPage label="Chargement des commandes..." />;
    }

    return (
        <div className="commands-page">
            <button onClick={() => {window.location.href = `/project/${projectId}`}} className="commands-page-back-btn">Retour</button>
            <div className="commands-page-header">
                <h1>Commandes</h1>
            </div>
            <div className="commands-list">
                {commands.map((command) => (
                    <div key={command.id}>
                        <EditCommandModal command={command} fetchCommands={loadCommands} />
                    </div>
                ))}
            </div>
            <button className="commands-page-refresh-btn" onClick={loadCommands}>Actualiser</button>
        </div>
    );
}